var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertficate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.501,
    height: 31.16,
    viewBox: "0 0 29.501 31.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:none;opacity:.05}.prefix__cls-2{fill:#024AD8}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__PDF-icon-desktop",
    transform: "translate(-18.5 -15.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1007",
    "data-name": "Group 1007",
    transform: "translate(26.395 24.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1568",
    d: "M0 0H6.232V6.232H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 1568",
    transform: "translate(3.739 3.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1569",
    d: "M0 0H13.71V13.71H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 1569"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1008",
    "data-name": "Group 1008",
    transform: "translate(20.525 18.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1570",
    d: "M0 0H25.451V25.13H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 1570"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1013",
    "data-name": "Group 1013",
    transform: "translate(18.5 15.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_523",
    d: "M98 112.033V94.708a1.651 1.651 0 0 0-1.7-1.6h-4.534v.737H96.3a.889.889 0 0 1 .914.86V111.3H70.2a.889.889 0 0 1-.914-.86V93.848h5.431v-.737H68.5v17.325a1.651 1.651 0 0 0 1.7 1.6h10.456v2.843H76.4v.737h13.841v-.737H85.86v-2.843zm-12.924 2.843h-3.637v-2.843h3.638z",
    className: "prefix__cls-2",
    "data-name": "Path 523",
    transform: "translate(-68.5 -84.452)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1012",
    "data-name": "Group 1012",
    transform: "translate(5.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1009",
    "data-name": "Group 1009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_524",
    d: "M113.872 77.563h-7.779v-.935h6.844v-9.279a1.092 1.092 0 0 0-1.091-1.091H96.4v9.279a1.092 1.092 0 0 0 1.091 1.091h5.755v.935h-5.754a2.028 2.028 0 0 1-2.025-2.025V65.324h16.38a2.028 2.028 0 0 1 2.025 2.025z",
    className: "prefix__cls-2",
    "data-name": "Path 524",
    transform: "translate(-95.467 -65.324)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_1010",
    "data-name": "Group 1010",
    transform: "translate(2.978 3.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_525",
    d: "M105.223 81.156q-.2 0-.2-.191v-5.473q.366-.066.824-.112t.857-.045a2.148 2.148 0 0 1 1.48.433 1.884 1.884 0 0 1 .474 1.447 2.587 2.587 0 0 1-.129.873 1.5 1.5 0 0 1-.362.582 1.4 1.4 0 0 1-.57.328 2.521 2.521 0 0 1-.744.1 3.774 3.774 0 0 1-.457-.029q-.242-.029-.508-.087v2.171zm.665-2.836q.216.042.432.071a3.252 3.252 0 0 0 .433.029 1.785 1.785 0 0 0 .466-.054.683.683 0 0 0 .328-.191.889.889 0 0 0 .2-.37 2.68 2.68 0 0 0 0-1.206.792.792 0 0 0-.212-.362.748.748 0 0 0-.345-.175 2.115 2.115 0 0 0-.462-.046q-.249 0-.47.017t-.362.041z",
    className: "prefix__cls-2",
    "data-name": "Path 525",
    transform: "translate(-105.023 -75.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_526",
    d: "M119.929 81.156q-.2 0-.2-.191v-5.473q.192-.033.412-.062t.449-.05c.152-.013.3-.025.445-.033s.28-.012.408-.012a3.062 3.062 0 0 1 1.015.15 1.534 1.534 0 0 1 .7.491 2.215 2.215 0 0 1 .4.9 7.295 7.295 0 0 1 0 2.728 2.324 2.324 0 0 1-.4.9 1.5 1.5 0 0 1-.686.5 2.913 2.913 0 0 1-1 .154zm1.48-5.123q-.192 0-.424.017t-.383.042v4.366h.79a2.2 2.2 0 0 0 .624-.079.823.823 0 0 0 .441-.32 1.715 1.715 0 0 0 .258-.686 8.278 8.278 0 0 0 .012-2.246 1.735 1.735 0 0 0-.233-.665.826.826 0 0 0-.428-.337 2.046 2.046 0 0 0-.657-.092z",
    className: "prefix__cls-2",
    "data-name": "Path 526",
    transform: "translate(-115.147 -75.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_527",
    d: "M138.957 76.235h-2.287v1.8h1.83a.169.169 0 0 1 .191.192v.532h-2.021v2.52H136q-.2 0-.2-.191V75.52h2.969a.169.169 0 0 1 .191.192z",
    className: "prefix__cls-2",
    "data-name": "Path 527",
    transform: "translate(-126.208 -75.462)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_528",
    d: "M121.617 104.543h-1.542v-3.017h-.935v3.016h-1.54c-.384 0-.542.268-.35.6l2.051 3.618c.192.327.419.328.611 0l2.055-3.616c.192-.332.033-.6-.35-.601z",
    className: "prefix__cls-2",
    "data-name": "Path 528",
    transform: "translate(-110.406 -90.245)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertficate);
export default __webpack_public_path__ + "static/media/certficate.525297c2194295a30c2e0a5843e8632e.svg";
export { ForwardRef as ReactComponent };